import React from 'react';
import { BookOpenIcon, CalendarIcon, ClockIcon, CreditCardIcon, FileTextIcon, GiftIcon, LockIcon, MessageCircleIcon, ShieldCheckIcon, StarIcon, UsersIcon } from 'lucide-react';
import { Button } from './ui/Button';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/e5xKrH7h7jPoypXvENXzQ3/ChatGPT_Image_18_jul_2026,_12_04_58_p.m..png';
export function Hero() {
  return <section className="relative overflow-hidden px-4 pb-14 pt-9 md:pb-20 md:pt-16" data-id="element-219" data-mp="129qtzk94hnnc">
      <div className="pointer-events-none absolute left-1/2 top-[18%] h-[540px] w-[540px] -translate-x-1/2 rounded-full bg-teal/10 blur-[110px]" data-id="element-220" data-mp="xanqw5cpdri0" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-221" data-mp="s9q7xqjvctfg">
        <div className="mb-5 inline-flex rounded-full border border-teal/20 bg-teal/10 px-4 py-1.5 font-display text-[11px] font-bold uppercase tracking-wider text-primary md:mb-7" data-id="element-222" data-mp="ncztf7npq5w5">
          🛒 Compra Digital Ya™
        </div>

        <h1 className="mx-auto max-w-4xl text-[1.75rem] font-extrabold leading-[1.1] tracking-tight text-slate-900 md:text-6xl" data-id="element-223" data-mp="380vyhwiiarcm">
          Tus ventas por redes,{' '}
          <span className="text-teal" data-id="element-224" data-mp="3o7vk1k75dnxa">listas desde hoy.</span>
        </h1>

        <p className="mx-auto mt-4 max-w-3xl text-base font-medium leading-relaxed text-slate-600 md:mt-6 md:text-xl" data-id="element-225" data-mp="39acwuma4biry">
          El sistema completo para emprendedores argentinos que quieren vender más
          por Instagram, Facebook y WhatsApp sin gastar un peso en publicidad.
        </p>

        <a href="#pricing" className="group my-5 flex justify-center rounded-3xl focus:outline-none md:my-7" aria-label="Ir a la sección de compra del Combo Completo Ventas Sin Publicidad" data-id="element-226" data-mp="358rckfv9827q">
          <img className="w-[96%] max-w-[760px] object-contain drop-shadow-[0_24px_38px_rgba(7,59,92,.20)] transition-transform duration-300 group-hover:scale-[1.015]" src={mockupUrl} alt="Mockup del Combo Completo Ventas Sin Publicidad con los cinco tomos y bonos incluidos" data-id="element-227" data-mp="2vi54d6pvadz2" />
        </a>

        <p className="font-bold text-slate-900 md:text-lg" data-id="element-228" data-mp="s3mf683jc910">
          Combo Completo Ventas Sin Publicidad — 5 Tomos + 5 Bonos Estratégicos
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-medium text-slate-600 md:text-sm" data-id="element-229" data-mp="iboyiltrcouw">
          <span className="flex items-center gap-1.5" data-id="element-230" data-mp="de6r4zve2hp0">
            <FileTextIcon className="h-4 w-4 text-teal" data-id="element-231" data-mp="1b0vv3f9nj4di" />
            100% PDF
          </span>
          <span className="flex items-center gap-1.5" data-id="element-232" data-mp="161t3awiomunh">
            <ClockIcon className="h-4 w-4 text-teal" data-id="element-233" data-mp="163436l90bi9b" />
            Acceso en 5 min
          </span>
          <span className="flex items-center gap-1.5" data-id="element-234" data-mp="111ew1gownoqi">
            <CalendarIcon className="h-4 w-4 text-teal" data-id="element-235" data-mp="x1edpkyoqte6" />
            Sistema 2026
          </span>
          <span className="flex items-center gap-1.5" data-id="element-236" data-mp="3lsp3hdsd4jef">
            <MessageCircleIcon className="h-4 w-4 text-teal" data-id="element-237" data-mp="3lu9vowr7fq94" />
            Aplicable hoy
          </span>
        </div>

        <div className="mt-7" data-id="element-238" data-mp="3htq0vzu3syq5">
          <Button href="#pricing" className="w-full bg-[#d81f2a] text-sm shadow-[0_10px_25px_rgba(216,31,42,.28)] hover:bg-[#b91822] md:w-auto md:px-10 md:py-5 md:text-lg" data-id="element-239" data-mp="1x9ulmd6nbhoh">
            QUIERO EL COMBO COMPLETO VENTAS SIN PUBLICIDAD
          </Button>
        </div>

        <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-medium text-slate-500 md:text-sm" data-id="element-240" data-mp="2b198iv3oc30t">
          <span className="flex items-center gap-1" data-id="element-241" data-mp="2fz0y3igujd1u">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-teal" data-id="element-242" data-mp="2kyna5okxun92" />
            Garantía 7 días
          </span>
          <span className="text-slate-300" data-id="element-243" data-mp="2ozz3a430tqm0">·</span>
          <span className="flex items-center gap-1" data-id="element-244" data-mp="2p1a5w0kqcsbj">
            <LockIcon className="h-3.5 w-3.5 text-teal" data-id="element-245" data-mp="2u03kjwbr6pda" />
            Pago seguro
          </span>
          <span className="text-slate-300" data-id="element-246" data-mp="umzf3mkkro34">·</span>
          <span className="flex items-center gap-1" data-id="element-247" data-mp="uoany0svnm13">
            <CreditCardIcon className="h-3.5 w-3.5 text-teal" data-id="element-248" data-mp="zkr9cn8ozmah" />
            Mercado Pago
          </span>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-4" data-id="element-249" data-mp="4a2u7jchl7z3">
          <div className="flex flex-col items-center gap-2 rounded-2xl border border-sky-100 bg-white p-3 shadow-sm" data-id="element-250" data-mp="3vignm664gdyb">
            <UsersIcon className="h-5 w-5 text-teal" data-id="element-251" data-mp="e88ww364ai50" />
            <span className="text-center text-[11px] font-bold leading-tight text-slate-800 md:text-sm" data-id="element-252" data-mp="9aqjo0l2hgr7">
              +1.000 emprendedores ya lo usan
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 rounded-2xl border border-sky-100 bg-white p-3 shadow-sm" data-id="element-253" data-mp="3hnxrgcgru6og">
            <BookOpenIcon className="h-5 w-5 text-teal" data-id="element-254" data-mp="3rftv031mmp02" />
            <span className="text-center text-[11px] font-bold leading-tight text-slate-800 md:text-sm" data-id="element-255" data-mp="3rhepjsnxy7xx">
              5 Tomos para vender por redes
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 rounded-2xl border border-sky-100 bg-white p-3 shadow-sm" data-id="element-256" data-mp="2yyhpdkpfu65x">
            <GiftIcon className="h-5 w-5 text-teal" data-id="element-257" data-mp="2u0g02i1f5am0" />
            <span className="text-center text-[11px] font-bold leading-tight text-slate-800 md:text-sm" data-id="element-258" data-mp="19idr29knwbrt">
              5 Bonos estratégicos incluidos
            </span>
          </div>
          <div className="flex flex-col items-center gap-2 rounded-2xl border border-sky-100 bg-white p-3 shadow-sm" data-id="element-259" data-mp="zkr7h9sf3w1i">
            <StarIcon className="h-5 w-5 fill-gold text-gold" data-id="element-260" data-mp="14isqjupufvcz" />
            <span className="text-center text-[11px] font-bold leading-tight text-slate-800 md:text-sm" data-id="element-261" data-mp="1s958lyesz8ha">
              4.9/5 · Cinco estrellas
            </span>
          </div>
        </div>
      </div>
    </section>;
}